import React, { useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  makeStyles,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { selectLanguage } from "../language/languageSlice";
import { selectName } from "../name/nameSlice";
import { selectCompany } from "../company/companySlice";
import { selectEmail } from "../email/emailSlice";
import { selectConsent } from "../consent/consentSlice";
import {
  selectTelephone,
  selectTelephoneCountryCode,
} from "../telephone/telephoneSlice";
import { selectAddress } from "../address/addressSlice";
import { selectBussinesstype } from "../businesstype/bussinesstypeSlice";
import { selectMessage } from "../message/messageSlice";
import {
  selectcustomerCountry,
  selectcustomerProvince,
  getListofProvince,
  selectCountryName,
} from "../customercountry/customercountrySlice";
import * as createleadApi from "../../utils/createleadapi";
import { selectCountry } from "../country/countrySlice";
import { red } from "@material-ui/core/colors";
import { clear, getListofBussinesstype, set } from "./submitbuttonSlice";
import { getListofRequestproduct } from "../requestProduct/requestproductSlice";
import styles from "./Submitbutton.module.css";
import {
  setContent,
  setLevel,
  setOpen as SnackOpen,
} from "../snackAlert/snackAlertSlice";
import { useSpring, animated } from "react-spring/web.cjs";
import PropTypes from "prop-types";
import {
  selectAttachedfile,
  setUploadfileInfo,
} from "../attachedfile/attachedfileSlice";
import { Consent } from "../consent/Consent";
import { SportsRugbySharp } from "@material-ui/icons";
import { Divider } from "material-ui";
const RedCheckbox = withStyles({
  root: {
    color: red[400],
    "&$checked": {
      color: red[600],
    },
    "&>span": {
      color: red[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
  textColor: {
    color: red[50],
  },
  button: {
    color: red[50],
    backgroundColor: red["A700"],
  },
  modalRoot: {
    maxWidth: "80vw",
    maxHeight: "80vh",
  },
  modal: {
    outline: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    fontFamily: "scgregular",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 25,
    border: "1px solid #d50000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  buttonDialog: {
    color: red["A700"],
  },
  modalContent: {
    minHeight: "80vh",
  },
  requestProductContent: {
    height: "20vh",
  },
  DialogContain: {
    minWidth: "60vw",
    // maxWidth:"60vw"
  },
}));
const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element,
  in: PropTypes.bool.isRequired,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
};
export function SubmitButton() {
  const classes = useStyles();
  const requestProduct = useSelector(getListofRequestproduct);
  const dispatch = useDispatch();
  const name = useSelector(selectName);
  const company = useSelector(selectCompany);
  const email = useSelector(selectEmail);
  const consent = useSelector(selectConsent);
  const telephone = useSelector(selectTelephone);
  const countryCode = useSelector(selectTelephoneCountryCode);
  const businesstype = useSelector(selectBussinesstype);
  const address = useSelector(selectAddress);
  const language = useSelector(selectLanguage);
  const cusCountry = useSelector(selectcustomerCountry);
  const cusCountryName = useSelector(selectCountryName);
  const cusProvince = useSelector(selectcustomerProvince);
  const listProvinceName = useSelector(getListofProvince);
  const exCountry = useSelector(selectCountry);
  const description = useSelector(selectMessage);
  const attachedFile = useSelector(selectAttachedfile);

  // const [incrementAmount, setIncrementAmount] = useState("2");

  const [open, setOpen] = React.useState(false);
  let AmountWord = language === "TH" ? " จำนวน " : "  ";
  const [dialogcontent, setDialogcontent] = React.useState(
    <DialogContentText
      id="alert-dialog-description"
      className={classes.DialogContain}
    >
      <div className={classes.requestProductContent}>
        {requestProduct
          .filter((reqPrd) => reqPrd.CurrentVol >= reqPrd.minQty)
          .map((reqPrd) => (
            <div>
              <Typography>
                {
                  reqPrd.Name +
                    (reqPrd.CurrentVol !== 0
                      ? AmountWord +
                        reqPrd.CurrentVol +
                        "  " +
                        reqPrd.Unit.filter(
                          (p) => p.id === reqPrd.CurrentUnit
                        )[0].Name
                      : "") /* {reqPrd.Name + reqPrd.CurrentVol !== 0
                ? AmountWord
                : "" + reqPrd.CurrentVol !== 0
                ? reqPrd.CurrentVol
                : "" + reqPrd.CurrentVol !== 0
                ? "  "
                : "" + reqPrd.CurrentVol !== 0
                ? reqPrd.Unit.filter((p) => p.id === reqPrd.CurrentUnit)[0].Name
                : ""} */
                }
              </Typography>
            </div>
          ))}
      </div>

      <Consent />
    </DialogContentText>
  );
  const handleOpen = () => {
    setOpen(true);
    setDialogcontent(
      <DialogContentText
        id="alert-dialog-description"
        className={classes.DialogContain}
      >
        {requestProduct
          .filter((reqPrd) => reqPrd.CurrentVol >= reqPrd.minQty)
          .map((reqPrd) => (
            <div>
              <FormControlLabel
                control={
                  <RedCheckbox checked disabled className={classes.textColor} />
                }
                label={
                  reqPrd.Name +
                  (reqPrd.CurrentVol !== 0
                    ? AmountWord +
                      reqPrd.CurrentVol +
                      "  " +
                      reqPrd.Unit.filter((p) => p.id === reqPrd.CurrentUnit)[0]
                        .Name
                    : "")

                  // reqPrd.Name + reqPrd.CurrentVol !== 0
                  //   ? AmountWord
                  //   : "" + reqPrd.CurrentVol !== 0
                  //   ? reqPrd.CurrentVol
                  //   : "" + reqPrd.CurrentVol !== 0
                  //   ? "  "
                  //   : "" + reqPrd.CurrentVol !== 0
                  //   ? reqPrd.Unit.filter((p) => p.id === reqPrd.CurrentUnit)[0]
                  //       .Name
                  //   : ""
                }
              ></FormControlLabel>
            </div>
          ))}

        <Consent />
      </DialogContentText>
    );
    requestProduct
      .filter((reqPrd) => reqPrd.CurrentVol < reqPrd.minQty)
      .map((reqPrd) => {
        dispatch(SnackOpen(true));
        dispatch(
          setContent(reqPrd.Name + "Quantity does not meet required value")
        );
        dispatch(setLevel("error"));
      });
    if (
      requestProduct.filter((reqPrd) => reqPrd.CurrentVol >= reqPrd.minQty)
        .length === 0
    ) {
      //handleClose();
    }
  };
  const handleSend = () => {
    let SendObj = {};
    let requestProductConfirm = [];

    requestProduct
      .filter((reqPrd) => reqPrd.CurrentVol >= reqPrd.minQty)
      .map((reqPrd) => {
        let prdObj = {};
        prdObj["ProductGroupId"] = reqPrd.id;
        prdObj["ProductUnitId"] = reqPrd.CurrentUnit;
        prdObj["EstimatedVolume"] = reqPrd.CurrentVol ?? "0";
        prdObj["BussinessunitId"] = reqPrd.buId;
        requestProductConfirm = [...requestProductConfirm, prdObj];
      });

    let regName = name;
    if (name === null || name === "") {
      dispatch(SnackOpen(true));
      dispatch(setContent("Name cannot be empty"));
      dispatch(setLevel("error"));
      setOpen(false);
      return;
    }
    while (/  /.test(regName)) {
      regName = regName.replace("  ", " ");
    }
    let [Name1, Name2] = regName.split(/\s(.+)/);
    SendObj["FirstName"] = Name1;
    SendObj["LastName"] = Name2 || "";
    if (company === null || company === "") {
      dispatch(SnackOpen(true));
      dispatch(setContent("company cannot be empty"));
      dispatch(setLevel("error"));
      setOpen(false);
      return;
    }

    SendObj["CompanyName"] = company;

    if (email === null || email === "") {
      dispatch(SnackOpen(true));
      dispatch(setContent("email cannot be empty"));
      dispatch(setLevel("error"));
      setOpen(false);
      return;
    }
    SendObj["EmailAddress1"] = email;

    if (telephone === null || telephone === "") {
      dispatch(SnackOpen(true));
      dispatch(setContent("telephone cannot be empty"));
      dispatch(setLevel("error"));
      setOpen(false);
      return;
    }
    SendObj["MobilePhone"] = countryCode + telephone[0];
    SendObj["Mob"] = telephone[0];
    SendObj["prefixMob"] = countryCode;
    if (address === null || address === "") {
      dispatch(SnackOpen(true));
      dispatch(setContent("address cannot be empty"));
      dispatch(setLevel("error"));
      setOpen(false);
      return;
    }
    SendObj["Address1_Line1"] = address;

    if (cusCountry === null || cusCountry === "") {
      dispatch(SnackOpen(true));
      dispatch(setContent("Country cannot be empty"));
      dispatch(setLevel("error"));
      setOpen(false);
      return;
    }
    SendObj["CountryId"] = cusCountry;
    SendObj["CountryName"] = cusCountryName;
    SendObj["ProvinceId"] = cusProvince;
    if (cusProvince !== null || cusProvince !== "")
      if (language === "TH") {
        SendObj["ProvinceName"] = listProvinceName.filter(
          (pv) => pv.Id === cusProvince
        )[0]?.NameTH;
      } else {
        SendObj["ProvinceName"] = listProvinceName.filter(
          (pv) => pv.Id === cusProvince
        )[0]?.Name;
      }

    if (businesstype === null || businesstype === "") {
      dispatch(SnackOpen(true));
      dispatch(setContent("bussinesstype cannot be empty"));
      dispatch(setLevel("error"));
      setOpen(false);
      return;
    }
    SendObj["CustomerBusinessTypeId"] = businesstype;

    if (exCountry === null || exCountry === "") {
      dispatch(SnackOpen(true));
      dispatch(setContent("Export Country cannot be empty"));
      dispatch(setLevel("error"));
      setOpen(false);
      return;
    }
    SendObj["CountryExportToId"] = exCountry;

    let countRejected = consent.filter((c) => c.status == false);
    if (countRejected.length > 0) {
      dispatch(SnackOpen(true));
      dispatch(setContent("Consent must be accept all"));
      dispatch(setLevel("error"));
      setOpen(false);
      return;
    }
    SendObj["Consent"] = consent;
    
    SendObj["Language"] = language;
    SendObj["Description"] = description;
    SendObj["RequestProduct"] = requestProductConfirm;
    
    setDialogcontent(
      <div className={styles.ldsdefault}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
    //console.log('SendObj: ',SendObj);
    createleadApi
      .createleadoncrm(SendObj)
      .then((data) => {
        //console.log(response);
        //     console.log(data)
        if (
          attachedFile !== null &&
          attachedFile !== undefined &&
          attachedFile.FileSize > 0
        ) {
          dispatch(
            setUploadfileInfo({
              fileguid: data.fileGuid,
              firstname: SendObj["FirstName"],
              lastname: SendObj["LastName"],
            })
          );
        } 
        //else {
          dispatch(SnackOpen(true));
          dispatch(setContent("Thank you for your attendtion"));
          dispatch(setLevel("success"));
          setTimeout(() => {
            handleClose();
            window.location.reload(false);
          }, 2000);
        //}
      })
      .catch((error) => {
        console.log(error);
        dispatch(SnackOpen(true));
        dispatch(setContent(error));
        dispatch(setLevel("error"));
        handleClose();
      });
    // console.log(SendObj);
    //SendObj["FirstName"] = "";
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        fullWidth
        variant="contained"
        onClick={handleOpen}
        className={classes.button}
        component="span"
      >
        Submit
      </Button>
      <Dialog
        maxWidth={"lg" | "md" | "sm" | "xl" | "xs"}
        className={classes.DialogContain}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {language === "TH"
            ? "กรุณายืนยันข้อมูลของท่าน"
            : "Kindly Confirm your request"}
        </DialogTitle>
        <DialogContent className={classes.modalContent}>
          {dialogcontent}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} className={classes.buttonDialog}>
            {language === "TH" ? "ยกเลิก" : "Cancel"}
          </Button>
          <Button
            onClick={handleSend}
            className={classes.buttonDialog}
            autoFocus
          >
            {language === "TH" ? "ยืนยัน" : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
